import React from 'react'

import Meadlight_Banner from '../assets/images/meadlight.png'
import meadlight_responsive from "../assets/images/meadlight-responsive.jpg"
import meadlight_video from "../assets/videos/meadlight-video.mp4"
import next_prev from "../assets/images/log-out.png"

import { motion } from 'framer-motion'
import ReactPlayer from 'react-player'
import "./Project.scss"
import { useNavigate } from 'react-router'


const content = (isFirstMount) => ({
    animate: {
        transition: { staggerChildren: 0.1, delayChildren: isFirstMount ? 2.8 : 0 },
    },
});

const title = {
    initial: { y: -20, opacity: 0 },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.7,
            ease: [0.6, -0.05, 0.01, 0.99],
        },
    },
};

export default function Meadlight({ isFirstMount }) {
    let navigate = useNavigate();
    function handleClick() {
        navigate("/");
    }
    return (
        <motion.div exit={{ opacity: 0 }} className="individual_ones">
            {isFirstMount && <InitialTransition />}
            <motion.div
                initial="initial"
                animate="animate"
                variants={content(isFirstMount)}
                className="first6"
            >
                <section className="project_banner">
                    <div className="header">
                        <span className="" onClick={handleClick}>
                            Back To Main
                        </span>
                    </div>
                    <motion.div className="project_name"
                        variants={title}>
                        Meadlight PinkDrink
                    </motion.div>
                    <motion.div className="banner_image"
                        variants={title}>
                        <img src={Meadlight_Banner} alt="Fakeflix Banner"
                            loading='lazy'
                        />
                    </motion.div>
                </section>
                <section className="project_description">
                    <div className="row">
                        <div className="column"></div>
                        <div className="column title">
                            A clone of AWWWARDS Site Of The Day
                            winning website
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Timeline
                            </div>
                            <div className="para_details">
                                November 2021 - December 2021
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_heading">
                                Description
                            </div>
                            <div className="para_details">
                                <p>
                                    This website was created with the main purpose of learning 3D animations
                                    on a single page website. The design and animations are replicated as close
                                    as possible to the original website. It features flashy and state-of-the-art
                                    scroll animations with complex 3D graphics.
                                </p>
                                <p>
                                    Under this main feature, it also presents other subtle yet sophisticated
                                    animations like custom SVG hover effect, smooth carousel and text reveal.
                                    The background is textured and has noise, that are also custom made.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Link
                            </div>
                            <div className="para_details">
                                <a href="https://mead-light-pink-drink-version2.vercel.app/"
                                    target='_blank' rel='noreferrer'>
                                    mead-light-pink-drink-version2.vercel.app
                                </a>
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_heading">
                                Solution
                            </div>
                            <div className="para_details">
                                <p>
                                    The project is created in React.js and I used quite a lot of
                                    libraries to recreate the original website's animations. I used
                                    Blender to create the 3D bottle graphics. ScrollTrigger and GSAP
                                    utilized to animate the bottle on scroll. I also used react-three/fiber
                                    and react-three/drei to draw out the canvas for scroll. The other
                                    subtle animations like text-reveal and carousel are created with GSAP.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="demo_video">
                        <ReactPlayer
                            className='react-player fixed-bottom'
                            url={meadlight_video}
                            width='100%'
                            height='100%'
                            loop={true}
                            muted={true}
                            controls={false}
                            playing={true}
                        />
                    </div>
                    <div className="row">
                        <div className="column"></div>
                        <div className="column title">
                            TYPOGAPHY
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Merlod Norme Bold
                            </div>
                            <div className="para_details">
                                Title Typography
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_details only"
                                style={{ fontFamily: "Merlod Norme Bold" }}
                            >
                                <p>Aa Bb Cc Dd Ee Ff Gg Hh Ii</p>
                                <p>Jj Kk Ll Mm Nn Oo Pp Qq Rr</p>
                                <p>Ss Tt Uu Vv Ww Xx Yy Zz</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Merlod Norme Regular
                            </div>
                            <div className="para_details">
                                Website Typography
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_details only"
                                style={{ fontFamily: "Merlod Norme Regular" }}
                            >
                                <p>Aa Bb Cc Dd Ee Ff Gg Hh Ii</p>
                                <p>Jj Kk Ll Mm Nn Oo Pp Qq Rr</p>
                                <p>Ss Tt Uu Vv Ww Xx Yy Zz</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Merlod Norme Light
                            </div>
                            <div className="para_details">
                                Links Typography
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_details only"
                                style={{ fontFamily: "Merlod Norme Light" }}
                            >
                                <p>Aa Bb Cc Dd Ee Ff Gg Hh Ii</p>
                                <p>Jj Kk Ll Mm Nn Oo Pp Qq Rr</p>
                                <p>Ss Tt Uu Vv Ww Xx Yy Zz</p>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "4vw" }}>
                        <div className="column title">
                            Color Swatches
                        </div>
                        <div className="column">
                            <div className="swatch_container">
                                <div className="swatch">
                                    <div className="bg_color" style={{ backgroundColor: "#285EDE" }}></div>
                                    <h3 className="color_code">#FD7F94</h3>
                                </div>
                                <div className="swatch">
                                    <div className="bg_color" style={{ backgroundColor: "#464652" }}></div>
                                    <h3 className="color_code">#464652</h3>
                                </div>
                                <div className="swatch">
                                    <div className="bg_color" style={{ backgroundColor: "#FF91A3" }}></div>
                                    <h3 className="color_code">#FF91A3</h3>
                                </div>
                                <div className="swatch">
                                    <div className="bg_color" style={{ backgroundColor: "#E7E5EE" }}></div>
                                    <h3 className="color_code">#E7E5EE</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="project_footer">
                    <div className="responsive_image">
                        <img src={meadlight_responsive} alt=""
                            style={{ width: "100%", height: "100%" }}
                            loading='lazy'
                        />
                    </div>
                    <div className="other_projects">
                        <a href="/fakeflix" className="prev_project">
                            <img src={next_prev} alt="previous project" className="rotate"
                                loading='lazy'
                            />
                            <span>Previous Project</span>
                        </a>
                        <a href="/googlestories" className="next_project">
                            <span>Next Project</span>
                            <img src={next_prev} alt="next project"
                                loading='lazy'
                            />
                        </a>
                    </div>
                </section>
            </motion.div>
        </motion.div>
    )
}





const blackBox = {
    initial: {
        height: "100vh",
        bottom: 0,
    },
    animate: {
        height: 0,
        transition: {
            when: "afterChildren",
            duration: 1.5,
            ease: [0.87, 0, 0.13, 1],
        },
    },
};

const textContainer = {
    initial: {
        opacity: 1,
        width: "100%"
    },
    animate: {
        opacity: 0,
        transition: {
            duration: 0.3,
            when: "afterChildren",
        },
    },
};

const text = {
    initial: {
        y: 40,
    },
    animate: {
        y: 80,
        transition: {
            duration: 1.5,
            ease: [0.87, 0, 0.13, 1],
        },
    },
};


const InitialTransition = () => {

    return (
        <motion.div
            className="first1"
            initial="initial"
            animate="animate"
            variants={blackBox}
            onAnimationStart={() => {
                document.body.classList.add("overflow-hidden")
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            onAnimationComplete={() => {
                document.body.classList.remove("overflow-hidden")
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
        >
            <motion.svg variants={textContainer} className="first2">
                <pattern
                    id="pattern"
                    patternUnits="userSpaceOnUse"
                    width={800}
                    height={800}
                    className="text-white"
                >
                    <rect className="first3" />
                    <motion.rect
                        variants={text}
                        className="first4"
                    />
                </pattern>
                <text
                    className="first5"
                    textAnchor="middle"
                    x="50%"
                    y="50%"
                    style={{ fill: "url(#pattern)" }}
                >
                    meadlight pinkdrink
                </text>
            </motion.svg>
        </motion.div>
    );
};